import UpSellsCarousel from './UpSellsCarousel';

export default UpSellsCarousel;
